import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [

    {
      path: "/",
      redirect: "dashboard/reports",
      component: () => import("@/layouts/full-layout/Layout"),

    },
    {
      path: "/dashboard",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "reports",
          component: () => import("@/views/dashboard/dashboard"),
        },
      ]
    },
    {
      path: "/dashboard/reports",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "view/:id",
          component: () => import("@/views/booking/BookingDetail"),
        },
      ]
    },

    {

      path: "/account",
      redirect: "/account/usersetting",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "usersetting",
          component: () => import("@/views/account/AccountPage"),
        },
      ],
    },
    {
      path: "/product",
      redirect: "product",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "ProductPage",
          path: "view",
          component: () => import("@/views/products/ProductPage"),
        },
        {
          name: "ProductDetail",
          path: "product_detail/:id/:action",
          component: () => import("@/views/products/ProductView"),
        },
        {
          name: "ProductPage",
          path: "add",
          component: () => import("@/views/products/AddProduct"),
        },
      ],
    },

    {
      path: "/customer",
      redirect: "customer",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CustomerPage",
          path: "view",
          component: () => import("@/views/customers/CustomerPage"),
        },
      ],
    },

    {
      path: "/users",
      redirect: "users",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "UserPage",
          path: "view",
          component: () => import("@/views/users/UserPage"),
        },
      ],
    },

    {
      path: "/market",
      redirect: "users",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "MarketProductPage",
          path: "view",
          component: () => import("@/views/market/MarketProductPage"),
        },
        {
          name: "AddMarketProduct",
          path: "add",
          component: () => import("@/views/market/AddMarketProduct"),
        },
        {
          name: "viewproductdetail",
          path: "product_detail/:id/:action",
          component: () => import("@/views/market/MarketProductView"),
        },
      ],
    },

    {
      path: "/wallet",
      redirect: "",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "MyWallet",
          path: "myWallet",
          component: () => import("@/views/wallet/MyWallet"),
        },
      ],
    },

    {
      path: "/booking",
      redirect: "",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "AllBooking",
          path: "all",
          component: () => import("@/views/booking/AllBooking"),
        },
        {
          name: "WaitingBooking",
          path: "waiting",
          component: () => import("@/views/booking/WaitingBooking"),
        },
        {
          name: "ConfirmBooking",
          path: "confirm",
          component: () => import("@/views/booking/ConfirmBooking"),
        },
        {
          name: "CancelBooking",
          path: "cancel",
          component: () => import("@/views/booking/CancelBooking"),
        },
        {
          name: "DoneBooking",
          path: "done",
          component: () => import("@/views/booking/DoneBooking"),
        },
        {
          name: "DoneBooking",
          path: "view/:id",
          component: () => import("@/views/booking/BookingDetail"),
        },
      ],
    },

    {
      path: "/authentication",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "BoxedLogin",
          path: "boxedlogin",
          component: () => import("@/views/authentication/BoxedLogin"),
        },
        {
          name: "FullLogin",
          path: "fulllogin",
          component: () => import("@/views/authentication/FullLogin"),
        },

        {
          name: "Error",
          path: "error",
          component: () => import("@/views/authentication/Error"),
        },
      ],
    },
  ],
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.

  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }

  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
